export const activitySlugMap = {
  'hot-yoga': 1,
  yoga: 2,
  boxing: 3,
  pilates: 4,
  'machine-gym': 5,
  circuit: 6,
  personal: 7,
  'dance-ballet': 8,
  cycling: 9,
  'dark-fitness': 10,
  swimming: 11,
  others: 12,
  surf: 13,
  stretch: 14,
  ems: 15,
  esthetic: 16,
  bouldering: 17,
  'aerial-yoga': 18,
  golf: 19,
  trampoline: 20,
  kickboxing: 21,
  running: 22,
  tennis: 23,
} as const

export const activitySlugs = Object.keys(
  activitySlugMap,
) as (keyof typeof activitySlugMap)[]
